import React, { Dispatch, useEffect, useRef } from "react";

type TerminalPopupPropsType = {
  windowState: Dispatch<React.SetStateAction<boolean>>;
  commands: string[];
  simulationName: string;
};

const TerminalPopup = (props: TerminalPopupPropsType) => {
  const terminalBodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (terminalBodyRef.current) {
      terminalBodyRef.current.scrollTop = terminalBodyRef.current.scrollHeight;
    }
  }, [props.commands]);

  return (
    <div className={`terminalWindow`}>
      {/* Title container */}
      <div className={`titleContainer`}>
        <span>{props.simulationName}</span>
        <div className={`titleButtonContainer`}>
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => props.windowState((prevState) => false)}
            onTouchStart={(e) => props.windowState((prevState) => false)}
          ></i>
        </div>
      </div>
      {/* Terminal body */}
      <div className={`terminalBody`} id="terminalBody" ref={terminalBodyRef}>
        {props.commands.map((item, index) => (
          <span key={index}>{item}</span>
        ))}
      </div>
    </div>
  );
};

export default TerminalPopup;
